import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=72c45374&scoped=true&"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js&"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLogo.vue?vue&type=style&index=0&id=72c45374&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c45374",
  null
  
)

export default component.exports